<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="checklists"
      item-key="id"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn
          :to="{ name: 'checklists-EditChecklist', query: { id: item.id } }"
          small
        >
          Edit
        </v-btn>
      </template>
    </v-data-table>
    <v-btn small @click="dialog = true" color="primary">New Checklist</v-btn>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title>
          <span class="headline">New Checklist</span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field v-model="checklistName" label="Checklist Name"></v-text-field>
            <v-select
              :items="checklistTypes"
              v-model="checklistType"
              label="Type"
            ></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="secondary" @click="closeDialog">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn :loading="isSaving" color="primary" @click="saveChecklist">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListCheckList',
  mixins: [loading],
  data() {
    return {
      dialog: false,
      checklistName: '',
      checklistType: 'Basic',
      checklistTypes: ['Basic', 'Custom'],
      headers: [
        { text: 'Checklist Name', value: 'name' },
        { text: 'Checklist Type', value: 'checklistType' },
        { text: '', value: 'actions', sortable: false },
      ],
    };
  },
  computed: {
    ...mapState('checklists', ['checklists']),
  },
  mounted() {
    this.refresh();
  },
  methods: {
    ...mapActions('checklists', ['CREATE_checklist', 'LOAD_checklists']),
    editChecklist(checklist) {
      this.dialog = true;
      this.checklistName = checklist.name;
    },
    async saveChecklist() {
      // save checklist
      this.isSaving = true;
      const result = await this.CREATE_checklist({
        name: this.checklistName,
        checklistType: this.checklistType,
      });
      this.checklistName = '';
      this.checklistType = 'Basic';
      this.isSaving = false;
      this.dialog = false;
      this.$router.push({ name: 'checklists-EditChecklist', query: { id: result.id } });
    },
    closeDialog() {
      this.dialog = false;
    },
    async refresh() {
      this.isLoading = true;
      await this.LOAD_checklists();
      this.isLoading = false;
    },
  },
};
</script>
